'use client'

import { Suspense } from 'react'
import dynamic from 'next/dynamic'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'

const Inbox = dynamic(() => import('../Inbox').then(module => module.default), {
  ssr: false,
})

const InboxWithLocation = () => {
  const { href } = useBrowserNavigation()

  return (
    <Suspense fallback={null}>
      <Inbox location={href} />
    </Suspense>
  )
}

export default InboxWithLocation
